import React, { useState } from 'react';
import {Field} from 'react-final-form';
import Select from 'react-select';
import classNames from 'classnames';
import InputValidationErrorMsg from './InputValidationErrorMsg';
import { selectAutocompleteStyles, Styled } from './CustomSelect.styles';
import InputLabel from './InputLabel';

const required = (value) => (value ? undefined : 'Required');
export interface CustomSelectProps {
    options: any[];
    name: string;
    isRequired?: boolean;
    label?: string;
    placeholder?: string;
    isMultiSelect?: boolean;
    isAutocomplete?: boolean;
    labelPropName: string;
    valuePropName: string;
    handleScroll?: (e: any) => void;
    handleSearch?: (e: any) => void;
    isDisabled?: boolean;
    sectionRequiredLabel?: string;
    valueIsString?: boolean;

}

const CustomSelect = ({
    options,
    name,
    isRequired = false,
    label = '',
    placeholder,
    isMultiSelect,
    labelPropName,
    valuePropName,
    handleScroll,
    handleSearch,
    isDisabled,
    sectionRequiredLabel,
    valueIsString = true
}: CustomSelectProps): JSX.Element => {

    const [selectedOption, setSelectedOption] = useState(null);
    const hasLessThan6Options = options.length < 6;

    return (
        <Styled className='custom-select' >
            <div key={label}>
                {label && <InputLabel htmlFor={name} label={label} required={isRequired}></InputLabel>}
                <Field name={name}>
                    {({meta}) => (
                        <div
                            className={classNames({
                                'validate-error': meta.error && meta.touched
                            })}>
                            <Field name={name} validate={(value)=>{return (isRequired && (!value && value !== 0) ? required(value) : undefined)}} disabled={isDisabled} >
                                {({input}) => (
                                    <>
                                    <Select
                                        isMulti={isMultiSelect}
                                        className="dropdown-autocomplete"
                                        readOnly={hasLessThan6Options ? true : false}
                                        isDisabled={isDisabled}
                                        styles={selectAutocompleteStyles}
                                        onMenuScrollToBottom={handleScroll}
                                        onInputChange={(newValue) => {
                                            if (!isMultiSelect && handleSearch) {
                                              handleSearch(newValue);
                                            }
                                          }}
                                        inputProps={{
                                        autoComplete: "off" // Turn off native browser input autoComplete
                                        }}
                                        placeholder={placeholder}
                                        options={options.map((opt) => ({
                                            label: opt[labelPropName],
                                            value: (valueIsString ? opt[valuePropName].toString() : opt[valuePropName])
                                        }))}
                                        value={meta.pristine? null : selectedOption}
                                        onChange={(option, context) => {
                                            setSelectedOption(option);
                                            input.onBlur();
                                            if (isMultiSelect && context.action === 'select-option') {
                                                input.onChange(option.map((opt) => {
                                                    return opt.value;
                                                }));
                                            } else {
                                                input.onChange(option?.value);
                                            }
                                        }}
                                        onBlur={() => {
                                            input.onBlur(); // trigger meta.touched
                                        }}

                                    />
                                    </>
                                )}
                            </Field>

                            {meta.error && meta.touched && (
                                <InputValidationErrorMsg error={meta.error} sectionRequiredLabel={sectionRequiredLabel} />
                            )}
                        </div>
                    )}
                </Field>
            </div>
        </Styled>
    );
};

export default CustomSelect;
